import { FC } from 'react';
import Link from 'next/link';

import { useAuth0User } from '@hooks/useAuth0User';
import { buildLoginHref } from '@lib/auth0/login-url';

const HUB_PATH = '/welcome';

/**
 * The page's exit link, deliberately deprioritised (small grey text, no
 * button) because the page drives users to the app instead. Users normally
 * arrive here still logged in: /thank-you force-refreshes their token
 * (re-running the Auth0 post-login Action so the new subscription claim is
 * already minted) before redirecting, so the link goes straight into the
 * hub. Logged-out visitors (e.g. a direct visit) are routed through login
 * first.
 */
const ReturnToHubLink: FC = () => {
  const { user, isLoading } = useAuth0User();

  if (isLoading) return null;

  return (
    <p className="mt-10 text-center">
      <Link
        prefetch={false}
        href={user ? HUB_PATH : buildLoginHref(HUB_PATH)}
        data-cy="funnel-welcome-return-link"
        className="font-open-sans text-xs text-neutral-500 underline hover:text-neutral-600"
      >
        Return to the Hub
      </Link>
    </p>
  );
};

export default ReturnToHubLink;
